import React from "react";
import { makeStyles } from "@material-ui/core";

// Tag chips on ticket cards used to render as solid-colored boxes
// using the raw `tag.color` from the database. On a dark theme that
// meant a row of bright orange / blue / red / purple bricks fighting
// the brand-green palette. Reworked to render as **tinted hairline
// pills**: the tag color is used as the *accent* (text + 1px border
// + 12% bg) instead of a full saturated fill. Premium look, original
// tag color still recognisable, no more rainbow against a green dark
// UI.
const useStyles = makeStyles((theme) => ({
  tag: {
    padding: "1px 7px",
    borderRadius: 6,
    fontSize: "0.78em",
    fontWeight: 600,
    marginRight: 5,
    marginBottom: 3,
    whiteSpace: "nowrap",
    lineHeight: 1.5,
    display: "inline-block",
  },
}));

// Convert "#rrggbb" or "#rgb" into an rgba() string at the given alpha.
const withAlpha = (hex, alpha) => {
  if (!hex || typeof hex !== "string") return `rgba(46, 227, 122, ${alpha})`;
  let h = hex.replace("#", "");
  if (h.length === 3) h = h.split("").map(c => c + c).join("");
  if (h.length !== 6) return `rgba(46, 227, 122, ${alpha})`;
  const r = parseInt(h.slice(0, 2), 16);
  const g = parseInt(h.slice(2, 4), 16);
  const b = parseInt(h.slice(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

const ContactTag = ({ tag }) => {
  const classes = useStyles();
  const color = tag?.color || "#2ee37a";

  return (
    <div
      className={classes.tag}
      style={{
        color: color,
        background: withAlpha(color, 0.12),
        border: `1px solid ${withAlpha(color, 0.28)}`,
      }}
    >
      {tag.name}
    </div>
  );
};

export default ContactTag;
